import script from "./FightsReorderModal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./FightsReorderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FightsReorderModal.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./FightsReorderModal.vue?vue&type=script&setup=true&lang=ts"

import "./FightsReorderModal.vue.css?vue&type=style&index=0&id=965efae8&lang=css!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./FightsReorderModal.vue?vue&type=style&index=0&id=965efae8&lang=css"

const __exports__ = script;

export default __exports__